var search = function(options){

	this.options = {
		$el: false
	};

	$.extend(true, this.options, options);

};

search.prototype.init = function(){

	var self = this;

  if (self.options.$el.hasClass('animate'))
  {
    self.options.$el.removeClass('large').addClass('small');
  }

};

module.exports = search;
